export default __webpack_public_path__ + "static/media/flag_code_dm.1d8ec674.png";